export default "__VITE_ASSET__CxkKdohO__"